import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "subtitle"
}




export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1),
      (__props.subtitle.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.subtitle), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})